export default __webpack_public_path__ + "static/getmojo_img-56fead0c3a411805296f7d6380066cd4.jpg";